import { combineReducers } from 'redux';
import CefApplicationReducer from "./Reducers/CefApplicationReducer";
import CefProgressReducer from "./Reducers/CefProgressReducer";
import PreferencesReducer from "./Reducers/PreferencesReducer";
export var rootReducer = combineReducers({
  CefApplication: CefApplicationReducer,
  CefProgress: CefProgressReducer,
  Preferences: PreferencesReducer
});